import databrain from '@/pages/opinion/assets/svg/databrain24.svg';
import mscienceImg from '@/pages/opinion/assets/svg/mscience-icon.svg';
import steamImg from '@/pages/opinion/assets/svg/channel/steam.svg';
import hatchetIcon from '@op/assets/svg/hatchet.svg';
import sensorTower from '@op/assets/svg/sensor_tower.svg';
import { textShowElement } from '@op/components/ChartCommon/formatter';

export const legendFormat = (params: any, formatMessage: any) => {
  if (params.includes('Sensor Tower')) {
    return `{sensorTower|}{a| ${formatMessage({ id: params })}}`;
  } else if (params.includes('Predicted')) {
    return `{databrainImg|}{a| ${formatMessage({ id: params })}}`;
  } else if (params.includes('CCV')) {
    return `{hatchetIconImg|}{a| ${formatMessage({ id: params })}}`;
  } else if (params.includes('PCU')) {
    return `{steamImg|}{a| ${formatMessage({ id: params })}}`;
  } else if (params.includes('Units')) {
    return `{mscienceImg|}{a| ${formatMessage({ id: params })}}`;
  } else if (params.includes('Digital Revenue')) {
    return `{mscienceImg|}{a| ${formatMessage({ id: params })}}`;
  } else {
    return params;
  }
};

const richImgMapFunc = () => {
  return [
    { key: 'databrainImg', icon: databrain },
    { key: 'sensorTower', icon: sensorTower },
    { key: 'mscienceImg', icon: mscienceImg },
    { key: 'steamImg', icon: steamImg },
    { key: 'hatchetIconImg', icon: hatchetIcon },
  ].reduce((pre: any, { key, icon }) => {
    return {
      ...pre,
      [key]: {
        height: 16,
        width: 16,
        backgroundColor: {
          image: icon,
        },
      },
    };
  }, {});
};

export const richImgMap = richImgMapFunc();

export const textShowFun = (formatMessage: any) => {
  return (marker: string, seriesName: string) => {
    if (
      [
        formatMessage({ id: 'Sentiment' }),
        formatMessage({ id: 'Brand Health' }),
      ].includes(seriesName)
    ) {
      const className =
        seriesName === formatMessage({ id: 'Sentiment' })
          ? 'sentiment'
          : 'brand-health';
      return `<span class="chart-common-formatter-marker ${className}">
        <span></span>  
      </span>&nbsp;${seriesName}`;
    }
    return textShowElement(marker, seriesName);
  };
};

export const sentimentBrandHealthLegend = (formatMessage: any) => [
  {
    name: formatMessage({ id: 'Sentiment' }),
    icon: 'path://M0 0 L12 0 L12 2 L0 2 Z',
    itemStyle: {
      color: '#29B569',
    },
  },
  {
    name: formatMessage({ id: 'Brand Health' }),
    icon: 'path://M0 0 L12 0 L12 2 L0 2 Z',
    itemStyle: {
      color: {
        type: 'linear',
        colorStops: [
          { offset: 0, color: '#CC5E6B' }, // 0% 处的颜色
          { offset: 0.5, color: '#CC5E6B' }, // 50% 处的颜色，与前一个相同
          { offset: 0.5, color: '#4DAB7D' }, // 50% 处的颜色开始变化
          { offset: 1, color: '#4DAB7D' }, // 100% 处的颜色
        ],
        global: false,
      },
    },
  },
];

export const visualMap = [
  {
    show: false,
    type: 'piecewise',
    seriesIndex: 1,
    pieces: [
      { gte: -100, lt: 0, color: '#CC5E6B' },
      { gte: 0, lte: 102, color: '#4DAB7D' },
    ],
  },
];
